// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2JHJe","title":"FrontImage_title__rlgI_"};